import {Component, HostListener, Inject} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

declare let $: any;

@Component({
   selector: 'app-create-folder',
   templateUrl: 'create-folder.component.html',
   styleUrls: ['create-folder.component.css']
})

export class CreateFolderComponent {
   error: string;
   toast: any;
   translate: any;
   shiftPressed = false;
   public canDrag: boolean;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<CreateFolderComponent>) {
   }

   /**
    *
    * @detail : Create folder in document
    */
   createFolder(button: any, input: any) {
      const value = input.value.trim();
      if (value.length === 0) {
         input.focus();
         return;
      }

      if (/[<|>\\\/:?*"]/g.test(value)) {
         /** Check input */
         this.data.translate.get('alert.create_folder_error').subscribe(s => {
            this.error = s;
         });
         return;
      }
      if (value.lastIndexOf('.') === value.length - 1 && this.data.type !== 'dropbox') {
         this.data.translate.get('alert.create_folder_error_dot').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }
      if (value.lastIndexOf('.') === value.length - 1 && this.data.type === 'dropbox') {
         this.data.translate.get('dropbox.rename_error_dot').subscribe(s => {
            if (this.toast) {
               this.toast.error(s);
            } else {
               this.error = s;
            }
         });
         return;
      }
      if(/(?=\p{Emoji})(?!\p{Number})/u.test(value.replace('#','')) && this.data.type === 'dropbox'){//dropbox filter emoji
         this.translate.get('dropbox.rename_error').subscribe(s => {
            this.error = s;
         });
         return;
      }
      button.disabled = true;
      if (this.data.type === 'dropbox') {
         const access_token = localStorage.getItem('access_token_dropbox');
         let path;
         if (this.data.path.trim() === '') {
            path = '/' + value;
         } else {
            path = '/' + this.data.path + '/' + value;
         }
         this.data.service.dropboxCreateFolder(access_token, path)
            .subscribe(res => {
               this.dialogRef.close();
               this.data.initDocument(this.data.path);
            }, error => {
               input.focus();
               button.disabled = false;
            })
      } else {
         const api = this.data.tin ? '/work/' + this.data.tin + '/folder' : '/folder';
         this.data.service.post(api, {name: value, destination: this.data.path, folderId: this.data.shareDocId})
            .subscribe(() => {
               this.dialogRef.close();
               this.data.showDocument();
            }, error => {
               input.focus();
               button.disabled = false;
            });

         this.dialogRef.close(true);
      }
   }

   /**
    *
    * @detail : When key down on keyboard 'A' button thumbnails will be selected all button
    * and when key down on keyboard 'D' button thumbnails will be unselected all button.
    */

   @HostListener('document:keydown', ['$event'])
   onKeyDown(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = true;
      } else if (e.key === 'a' && (e.ctrlKey || e.metaKey)) {
         e.preventDefault();
         e.stopPropagation();
         $('#name_folder').select();
      }
   }

   @HostListener('document:keyup', ['$event'])
   onKeyUp(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = false;
      }
   }
}

